import { jsPDF } from "jspdf";
//import autoTable from "jspdf-autotable";

const Rugilaba = (data, namaBulan, tahun) => {
  if (!data || data.length === 0) {
    alert("Tidak ada data untuk dicetak.");
    return;
  }

  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 10;
  const contentWidth = pageWidth - (2 * margin);

  const loadImageAsDataURL = (url) => {
  return fetch(url)
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );
};
const drawHeader = (logoDataUrl) => {
  const logoX = 10;
  const logoY = 8;
  const logoSize = 18;
  const textX = logoX + logoSize + 3;

  if (logoDataUrl) {
    doc.addImage(logoDataUrl, "PNG", logoX, logoY, logoSize, logoSize);
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("KPRI SRI REJEKI", textX, 14);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text("Jl. Donomulyo No.164 Kab. Malang", textX, 19);

  const lineY = logoY + logoSize + 3;

  doc.setLineWidth(0.3);
  doc.line(8, lineY, pageWidth - 8, lineY);
};

  namaBulan = namaBulan || "Tidak Diketahui";
  const periodeTahun = tahun || "Tidak Diketahui";

  // Judul PDF
  const titleLines = [
    "Laporan Rugi Laba",
    `${namaBulan} ${periodeTahun}`,
  ];

  doc.setFontSize(14);
  let yPos = 40;
  titleLines.forEach((line) => {
    doc.text(line, pageWidth / 2, yPos, { align: "center" });
    yPos += 6;
  });

  yPos += 10;

  const formatNumber = (num) => {
    return typeof num !== "number" || isNaN(num)
      ? "Rp. -"
      : "Rp. " + num.toLocaleString("id-ID");
  };

  let totalPendapatan = 0;
  let totalBeban = 0;
  let labaSebelumPajak = 0;
  let labaBersih = 0;
  let pajak = 0;

  // Mendapatkan data dari parameter 'data'
  const pendapatanData = data.filter((item) => item.posisi === "K");
  const bebanData = data.filter((item) => item.posisi === "D");
  const pajakItem = data.find((item) =>
    item.perkiraan.toLowerCase().includes("pajak")
  );
  if (pajakItem) {
    pajak = Number(pajakItem.saldo) || 0;
  }

  // Bagian Pendapatan
  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.text("Pendapatan", margin, yPos);
  yPos += 5;

  doc.setFont("helvetica", "normal");
  pendapatanData.forEach((item, index) => {
    const saldo = Number(item.mutasikd) - Number(item.mutasidb) || 0;
    const isGrayRow = index % 2 === 1;
    if (isGrayRow) {
      doc.setFillColor(240, 240, 240);
      doc.rect(margin, yPos - 4, contentWidth, 5, "F");
    }
    doc.text(item.perkiraan, margin + 5, yPos);
    doc.text(formatNumber(saldo), pageWidth - margin, yPos, { align: "right" });
    totalPendapatan += saldo;
    yPos += 5;
  });

  // Total Pendapatan
  yPos += 2;
  doc.setFont("helvetica", "bold");
  doc.text("Total pendapatan", margin + 5, yPos);
  doc.text(formatNumber(totalPendapatan), pageWidth - margin, yPos, {
    align: "right",
  });
  doc.line(pageWidth - 60, yPos - 5, pageWidth - margin, yPos - 5);
  doc.line(pageWidth - 60, yPos - 4.5, pageWidth - margin, yPos - 4.5);

  yPos += 10;

  // Bagian Beban
  doc.text("Beban", margin, yPos);
  yPos += 5;

  doc.setFont("helvetica", "normal");
  bebanData.forEach((item, index) => {
    const saldo = Number(item.mutasidb) - Number(item.mutasikd) || 0;
    // Kecualikan pajak dari beban
    if (!item.perkiraan.toLowerCase().includes("pajak")) {
      const isGrayRow = index % 2 === 1;
      if (isGrayRow) {
        doc.setFillColor(240, 240, 240);
        doc.rect(margin, yPos - 4, contentWidth, 5, "F");
      }
      doc.text(item.perkiraan, margin + 5, yPos);
      doc.text(formatNumber(saldo), pageWidth - 60, yPos, { align: "right" });
      totalBeban += saldo;
      yPos += 5;
    }
  });

  // Total Beban
  yPos += 2;
  doc.setFont("helvetica", "bold");
  doc.text("Total Beban", margin + 5, yPos);
  doc.text(formatNumber(totalBeban), pageWidth - 60, yPos, { align: "right" });
  doc.line(pageWidth - 110, yPos - 5, (pageWidth - 100) + 40, yPos - 5);
  doc.line(pageWidth - 110, yPos - 4.5, (pageWidth - 100) + 40 , yPos - 4.5);

  yPos += 10;

  // Laba Sebelum Pajak
  labaSebelumPajak = totalPendapatan - totalBeban;
  doc.setFont("helvetica", "bold");
  doc.text("Laba Sebelum Pajak", margin, yPos);
  doc.text(formatNumber(labaSebelumPajak), pageWidth - margin, yPos, {
    align: "right",
  });
  yPos += 5;

  // Pajak
  doc.setFont("helvetica", "normal");
  doc.text("Pajak", margin, yPos);
  doc.text(formatNumber(pajak), pageWidth - margin, yPos, { align: "right" });
  //doc.line(pageWidth - 60, yPos - 2, pageWidth - margin, yPos - 2);
  yPos += 8;

  // Laba Bersih
  labaBersih = labaSebelumPajak - pajak;
  doc.setFont("helvetica", "bold");
  doc.text("Laba Bersih", margin, yPos);
  doc.text(formatNumber(labaBersih), pageWidth - margin, yPos, {
    align: "right",
  });
  doc.line(pageWidth - 60, yPos - 5, pageWidth - margin, yPos - 5);
  doc.line(pageWidth - 60, yPos - 4.5, pageWidth - margin, yPos - 4.5);

  // Buka PDF di tab baru
 const renderPdf = () => {
  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl, "_blank");
};
const customLogoUrl = "/koperasihitamputih.png";

loadImageAsDataURL(customLogoUrl)
  .then((logoDataUrl) => {
    drawHeader(logoDataUrl);
    renderPdf();
  })
  .catch(() => {
    drawHeader();
    renderPdf();
  });
};

export default Rugilaba;